export const CheckIsAddOnMatch = (arr1: any, arr2: any) => {
    if (arr1.length !== arr2.length) return false;

    const mapKey = (item: any) =>
        `${item.addon_id}-${item.addon_item?.item_id}`;

    const keys1 = arr1.map(mapKey).sort();
    const keys2 = arr2.map(mapKey).sort();
    // console.log('-key11key2',keys1,keys2)

    return keys1.every((key: any, index: any) => key === keys2[index]);
};


export const CheckIsSelectedCategory= (arr1: any, arr2: any) => {
    if (arr1.length !== arr2.length) return false;

    const mapKey = (item: any) =>
        `${item.item_id}-${item.item_type_id}-${item?.side_id}-${item?.mapNewItem?.item_id}-${item?.mapNewItem?.item_type_id}`;

    const keys1 = arr1.map(mapKey).sort();
    const keys2 = arr2.map(mapKey).sort();
    // console.log('-key11key2',keys1,keys2)

    return keys1.every((key: any, index: any) => key === keys2[index]);
};

export const CheckIsSelectedOptions= (arr1: any, arr2: any) => {
    if (arr1.length !== arr2.length) return false;

    const mapKey = (item: any) =>
        `${item.item_id}-${item.step_id}-${item?.group_step_id}-${item?.item_step_option_id}`;

    const keys1 = arr1.map(mapKey).sort();
    const keys2 = arr2.map(mapKey).sort();
    console.log('-key11key2',keys1,keys2)

    return keys1.every((key: any, index: any) => key === keys2[index]);
};



export function formatAddressTwoLines(address:any) {
  if (!address) return { line1: "", line2: "" };

  const parts = address.split(",").map((part:any) => part.trim());

  if (parts.length <= 2) {
    return {
      line1: parts[0] || "",
      line2: parts[1] || ""
    };
  }

  const line2 = parts?.slice(-3).join(", ");
  const line1 = parts?.slice(0, -3).join(", ");

  return { line1, line2 };
}